import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import {
  ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../../PreActivation/components/FieldBlock";
import FieldHint from "../../PreActivation/components/FieldHint";
import FieldLabel from "../../PreActivation/components/FieldLabel";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import ReadOnlySectionGrid from "../../PreActivation/components/ReadOnlySectionGrid";

const AdditionalNotesSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <FieldBlock>
        <FieldLabel
          htmlFor="additionalNotes"
          text={t(ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES)}
        />
        <FieldHint text={t(ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES)} />
        <IntakeTextField
          name="additionalNotes"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          multiline
          minRows={5}
          readOnly={readOnly}
          placeholder={t(ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES)}
          variant="outlined"
        />
        <Box sx={{ mt: 1 }}>
          <FieldHint text={t(ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES)} />
        </Box>
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default AdditionalNotesSection;
